import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { documentUploaderTypes } from './document-uploader-type-selector.constants';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EDocumentUploaderMode } from './document-uploader-type-selector.enums';
import { IDocumentType } from './document-uploader-type-selector.models';

@Component({
  selector: 'app-document-uploader-type-selector',
  templateUrl: './document-uploader-type-selector.component.html',
  styleUrls: ['./document-uploader-type-selector.component.scss'],
})
export class DocumentUploaderTypeSelectorComponent {
  documentType: IDocumentType | null = null;
  @Output() selectDocument = new EventEmitter<IDocumentType>();
  protected readonly documentTypes: IDocumentType[] = documentUploaderTypes;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { mode: EDocumentUploaderMode },
    private dialog: MatDialogRef<DocumentUploaderTypeSelectorComponent>,
  ) {
  }

  get selectBtnLabel(): string {
    return this.data.mode === EDocumentUploaderMode.DRAG_AND_DROP ? 'Зберегти' : 'Продовжити';
  }

  selectDocuments(): void {
    this.selectDocument.emit(this.documentType);

    if (this.data.mode === EDocumentUploaderMode.DRAG_AND_DROP) {
      this.dialog.close();
    }
  }
}
